import { Box, Grid, Hidden, Typography } from '@mui/material';
import Image from 'next/image';
import DoctorIllustration from '../../public/DoctorIllustration.png';
import ProductShot from '../../public/MobileScreenshot.png';
import { EngagementEvents, logKariusEvent } from '../Analytics';
import IconAppleStore from '../assets/images/svg/IconAppleStore';
import IconGoogleStore from '../assets/images/svg/IconGoogleStore';
import Colors from '../theme/colors';

export const MobileMarketing = () => {
  return (
    <Grid
      container
      sx={{
        width: {
          md: '399px',
        },
        gap: {
          md: '16px',
          xs: '25px',
        },
      }}
      flexDirection='column'
      id='mobileMarketing'
    >
      <Hidden mdDown>
        <Box sx={{ width: '100%' }}>
          <Image
            layout='responsive'
            src={ProductShot}
            quality={100}
            alt='Karius App'
            placeholder='blur'
            data-test='app-image'
          />
        </Box>
      </Hidden>
      <Grid container justifyContent='center'>
        <Hidden mdUp>
          <Grid container maxWidth='500px' alignItems='center'>
            <Grid item xs={4} sx={{ width: '127px', paddingRight: '11px' }}>
              <Image layout='responsive' src={DoctorIllustration} alt='Doctor' />
            </Grid>
            <Grid item xs={8}>
              <PromoText />
            </Grid>
          </Grid>
        </Hidden>
        <Hidden mdDown>
          <PromoText />
        </Hidden>
      </Grid>
      <Grid
        justifyContent='center'
        flexDirection='row'
        container
        sx={{
          '& .download-btn': {
            height: '40px',
          },
          gap: '22px',
        }}
      >
        <Grid item>
          <a
            href='https://apps.apple.com/app/apple-store/id1524044861?pt=120542634&ct=online_portal_login&mt=8'
            onClick={() => logMobileTap('ios')}
          >
            <IconAppleStore className='download-btn' />
          </a>
        </Grid>
        <Grid item>
          <a
            href='https://play.google.com/store/apps/details?id=com.kariusdx.mobile&referrer=utm_source%3Donline_portal_login%26utm_medium%3Dplay_store_button'
            onClick={() => logMobileTap('android')}
          >
            <IconGoogleStore className='download-btn' />
          </a>
        </Grid>
      </Grid>
    </Grid>
  );
};

const PromoText = () => {
  return (
    <Grid
      container
      flexDirection='column'
      sx={{
        maxWidth: {
          md: '360px',
        },
        gap: {
          md: '7px',
          xs: '5px',
        },
        '& .promo-text': {
          textAlign: {
            md: 'center',
            xs: 'left',
          },
        },
      }}
    >
      <Typography
        variant='h5'
        className='promo-text'
        sx={{
          fontFamily: 'Arimo',
          fontStyle: 'normal',
          fontWeight: 'normal',
          fontSize: '20px',
          lineHeight: '28px',
          textAlign: 'left',
          color: Colors.blue,
        }}
      >
        Get the Karius App
      </Typography>
      <Typography
        variant='body2'
        className='promo-text'
        sx={{
          fontFamily: 'Roboto',
          fontStyle: 'normal',
          fontWeight: 'normal',
          fontSize: '16px',
          color: Colors.blue,
        }}
      >
        The most convenient way to get realtime updates on order status and view results. The Karius App does not yet
        support ordering tests.
      </Typography>
    </Grid>
  );
};

const logMobileTap = (os: 'android' | 'ios') => logKariusEvent(EngagementEvents.mobile_app_download_tapped, { os });
